/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_USER_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUserDropDownListsMethods extends IPluginMethodMap {
  getUserDropDownListsProps(args: any): Promise<any>;
}

export class UserDropDownListsService implements IAgentPlugin {
  readonly methods: IUserDropDownListsMethods;

  constructor() {
    this.methods = {
      getUserDropDownListsProps: this.getUserDropDownListsProps.bind(this),
    };
  }

  async getUserDropDownListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const whereClauses = this.createWhereClauses(args);

    try {
      if (client) {
        const res = await client.query({
          query: GET_USER_LIST,
          variables: {
            input: {
              where: whereClauses,
              order: [
                {
                  direction: "ASC",
                  column: "firstName",
                },
              ],
              invitedByMe: false,
            },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          return {
            selectDropDown: this.transformArray(res?.data?.getUserList?.data),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private createWhereClauses(args: any) {
    let whereCls: any[] = [];
    whereCls = [
      {
        column: "role",
        op: "Equal",
        value: ["99403c8b-abc1-4796-b61f-78e0c4022792"],
      },
    ];
    return whereCls;
  }
  private transformArray(array: any) {
    return array
      .map((item) => {
        const label = item.fullName || item.email;
        if (!label) {
          return null; // Ignore the item if both fullName and email are empty
        }
        return {
          id: item.email,
          label: label,
        };
      })
      .filter(Boolean); // Filter out any null values from the array
  }
}
